export const SET_MAP_DEFAULT_STATE = 'SET_MAP_DEFAULT_STATE';
